import parents from '../helpers/helpers';

window.Element.prototype.parents = parents;

const navWrap = document.querySelector('.js-nav-wrap');

export default class Menu {
  constructor() {
    this.body = document.body;
    this.nav = document.querySelector('.js-nav');

    if (this.nav && this.nav.querySelector('.js-navbar-menu-trigger')) {
      this.menuTrigger = this.nav.querySelector('.js-navbar-menu-trigger');
      this.isShown = false;
    }
    this.bind();
  }

  static handleMeganav() {
    const meganavLinks = document.querySelectorAll('.navbar .navbar__item');
    const siteHeader = document.querySelector('.header');
    function hideActiveMegaNav() {
      const activeMeganavItem = document.querySelector('.meganav-item.is-open');
      document.body.classList.remove('meganav-active');
      activeMeganavItem.classList.remove('is-open');
    }

    function hideCurrentMegaNav() {
      if (document.body.classList.contains('meganav-active')) hideActiveMegaNav();
    }

    meganavLinks.forEach((navLink) => {
      navLink.addEventListener('mousemove', () => {
        if (document.querySelector('.js-meganav-section.is-open')) hideActiveMegaNav();
        if (navLink.querySelector('.js-meganav-section')) {
          document.body.classList.add('meganav-active');
          navLink.classList.add('is-open');
        }
      });
      navLink.addEventListener('mouseleave', hideCurrentMegaNav);
    });
    siteHeader.addEventListener('mouseleave', hideCurrentMegaNav);
  }

  show() {
    this.isShown = true;
    this.body.classList.add('is-menu');
  }


  hide() {
    this.isShown = false;

    navWrap.classList.add('is-animating');
    setTimeout(() => {
      document.body.classList.remove('is-menu');
      navWrap.classList.remove('is-animating');
    }, 700);
  }


  toggleMenu() {
    if (!this.isShown) this.show();
    else this.hide();
  }


  bind() {
    if (this.menuTrigger) {
      this.menuTrigger.addEventListener('click', () => this.toggleMenu());
    } else Menu.handleMeganav();
  }
}
